import React, { useEffect, useRef } from "react";
import { useSnackbar } from "../../hooks/useSnackbar";
import styled from "styled-components";

import { Button } from "../../UI/MUIButton";

const NoChangeAnchor = styled.a`
  color: inherit;
  text-decoration: none;
`;

const DownloadCSVButton = ({ title, apiCall, type = "" }) => {
  const ref = useRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const clicked2 = useRef(false);

  const handleClick = async () => {
    setIsLoading(true);
    const response = await apiCall();
    if (type === "csv") {
      try {
        const url = window.URL.createObjectURL(response.blob);
        const a = ref.current;
        a.href = url;
        a.download = response.fileName;
        if (!clicked2.current) {
          clicked2.current = true;
          a.click();
        }
      } catch(e) {
        showErrorSnackbar(e);
      }
      

    }
    else if (response.ok) {
      showSuccessSnackbar("You will be notified on your email once the user report will be created");
    }
    else {
      showErrorSnackbar(response.error);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      // setClicked(false);
      clicked2.current = false;
    }, 200);
  }, [clicked2.current]);

  // eslint-disable-next-line
  const anchor = <NoChangeAnchor ref={ref}>{title}</NoChangeAnchor>;

  return (
    <Button color="primary" variant="contained" loading={isLoading} onClick={handleClick}>
      {anchor}
    </Button>
  );
};

export default DownloadCSVButton;
